module.exports = __webpack_public_path__ + "static/media/sfu-logo-header-mobile.cbac8e52.svg";